import { apiClient } from '../../../client'
import type { TenantWeek } from '../../user/user-routes.repository'

export interface TenantWeekFilters {
  year_no?: number
  week_no?: number
}

class CalendarRepository {
  async getTenantWeeks(filters?: TenantWeekFilters): Promise<TenantWeek[]> {
    const params = new URLSearchParams()
    if (filters?.year_no != null) params.append('year_no', String(filters.year_no))
    if (filters?.week_no != null) params.append('week_no', String(filters.week_no))
    const qs = params.toString()
    return apiClient.get<TenantWeek[]>(
      qs ? `/field-force/calendar/tenant-weeks?${qs}` : '/field-force/calendar/tenant-weeks',
    )
  }

  async exportToExcel(filters?: TenantWeekFilters): Promise<Blob> {
    const params = new URLSearchParams()
    if (filters?.year_no != null) params.append('year_no', String(filters.year_no))
    if (filters?.week_no != null) params.append('week_no', String(filters.week_no))
    const qs = params.toString()
    return apiClient.getBlob(
      qs
        ? `/field-force/calendar/tenant-weeks/export/excel?${qs}`
        : '/field-force/calendar/tenant-weeks/export/excel',
    )
  }
}

export const calendarRepository = new CalendarRepository()
